export interface VehicleBrand {
    id: number
    name: string
}

export interface VehicleModel {
    id: number
    name: string
    isHybrid: boolean
}

export interface VehicleVersion {
    id: number
    name: string
    brand: {
        id: number
        name: string
    }
    model: {
        id: number
        name: string
        isHybrid: boolean
    }
    acConnectorTypeId: number
    dcConnectorTypeId: number
    minWeight: number
    weight: number
    scx: number
    batterySize: number
    acChargeRate: number
    acOptionChargeRate: number
    dcChargeRate: number
    dcOptionChargeRate: number | null
    highwayAutonomy: number
    cityAutonomy: number
    highwayConsumption: number
    cityConsumption: number
    referenceConsumption: number | null
    dcChargeSteps: any[]
}

export interface DropdownOption {
    id: number
    value: string
}

export enum VehicleManagementView {
    LIST = 'list',
    FORM = 'form',
    DELETE = 'delete'
}
